<template>
  <container-slot>
    <v-col cols="12">
      <h1 class="display-1 font-weight-medium">Edit Role</h1>
    </v-col>
    <v-col cols="12" v-show="successSubmit">
      <v-alert
        :type="!error ? `success` : info ? `info` : `error`"
        ref="alert"
        dismissible
        @input="close"
        class="noMarg"
        v-show="successSubmit"
      >
        {{ msg }}
      </v-alert>
    </v-col>
    <v-col cols="12" md="4">
      <v-form ref="form" v-model="valid" @submit="submit">
        <v-text-field
          prepend-inner-icon="mdi-pencil"
          name="rolename"
          label="Role Name"
          id="rolename"
          type="text"
          v-model="roleName"
          :rules="roleNameRules"
          ref="roleNameInput"
          outlined
          required
        >
        </v-text-field>
        <v-btn
          :disabled="!valid"
          color="primary"
          @click="submit"
          ref="submitBtn"
          :loading="loading"
        >
          Submit
        </v-btn>
      </v-form>
    </v-col>
  </container-slot>
</template>

<script>
import ContainerSlot from "@/components/ContainerSlot";
import { getRoleById } from "@/utils/graphqlQuery";
import { editRole } from "@/utils/graphqlMutation";
import { roles } from "@/utils/graphqlQuery";

export default {
  apollo: {
    getRoleById: {
      query: getRoleById,
      update: function (data) {
        if (!data.getRoleById) {
          this.$router.replace({ path: "/role/edit" });
        } else {
          const { roleName } = data.getRoleById;
          this.roleName = roleName;
          return data.getRoleById;
        }
      },
      variables() {
        return {
          roleId: this.roleId,
        };
      },
    },
  },
  data() {
    return {
      error: false,
      info: false,
      msg: "",
      loading: false,
      roleId: this.$route.params.roleId,
      roleName: "",
      roleNameRules: [
        (v) => !!v || "Role Name is required",
        (v) => /^[A-Za-z0-9 ]{1,}$/.test(v) || "Role Name must be valid",
      ],
      successSubmit: false,
      valid: false,
    };
  },
  components: {
    ContainerSlot,
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      this.successSubmit = false;
      const that = this;
      if (this.valid) {
        this.loading = true;
        try {
          const gqlRoles = roles;
          const roleObj = {
            id: this.roleId,
            roleName: this.roleName,
          };
          const { data } = await this.$apollo.mutate({
            mutation: editRole,
            variables: {
              roleObj,
            },
            update: (store, { data: { editRole } }) => {
              try {
                if (editRole.success == 1) {
                  const cachedRoles = store.readQuery({ query: gqlRoles });
                  const mappedCache = cachedRoles.roles.map((r) =>
                    r.id == that.roleId ? { ...r, roleName: that.roleName } : r
                  );
                  store.writeQuery({
                    query: gqlRoles,
                    data: {
                      roles: mappedCache,
                    },
                  });
                  return mappedCache;
                }
              } catch (err) {
                // eslint-disable-next-line no-console
                console.log('No "roles" cache found');
                return null;
              }
            },
          });
          if (data.editRole) {
            const { success, msg } = data.editRole;
            if (success == 0) {
              throw new Error(msg);
            } else if (success == -1) {
              this.error = true;
              this.info = true;
              this.msg = msg;
            } else {
              this.error = false;
              this.msg = msg;
            }
          } else {
            this.error = true;
            this.msg = `Something went wrong`;
          }
        } catch (error) {
          this.error = true;
          this.msg = error.message;
        } finally {
          this.successSubmit = true;
          this.loading = false;
        }
      }
    },
    close() {
      this.successSubmit = false;
      this.msg = "";
      this.info = false;
    },
  },
  name: "EditRole",
  title() {
    return "Edit Role";
  },
};
</script>

<style scoped>
.noMarg {
  margin: 0;
}
</style>
